// ─── /app/reports — RETIRED (Phase 12 Batch 3 slice 3c) ───
// Reports was folded into Dashboards: the seeded "Project Status" + "Team
// Load" default dashboards reproduce every /app/reports widget, and the
// Dashboards canvas toolbar absorbed the scope picker + date range + CSV/XLSX
// export (via the widget-data `viewFilter` overlay). This route is kept ONLY
// as a permanent redirect alias so old bookmarks/shared links (and any
// lingering `to: '/app/reports'` navigations) still resolve — it repoints at
// the Dashboards index, which itself resolves to the "Project Status" default
// (DashboardsIndexPage §1.1). The `/api/v1/reports/*` endpoints stay live
// (the dashboards widget-data + export both reuse them).

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/reports')({
  beforeLoad: () => {
    throw redirect({ to: '/app/dashboards' });
  },
});
